<script>
import { api } from "@/state/services";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  methods: {
    delClient() {
      this.loading = true;

      api
        .post('exclusaoindividual/clients/delete', {
          id: this.id
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O cliente foi excluído com sucesso!");

            this.loading = false;
            this.show = false;

            this.$emit('deleted');
          } else {
            this.$toast.error(response.data.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao excluir cliente, tente novamente.");
            this.loading = false;
          }
        });
    },
  },
};
</script>

<template>
  <b-modal v-model="show" modal-class="modal-bottom" hide-footer hide-header>
    <div class="px-3">
      <h5>Você tem certeza que deseja excluir este cliente?</h5>
      <div class="mt-4 d-flex justify-content-between">
        <b-button class="btn-lg" variant="danger" :disabled="loading" v-on:click="delClient()">
          Excluir
          <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
        <b-button class="text-dark text-decoration-none" variant="link" v-on:click="show = false">Fechar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
